var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFollowuparrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7655 8.93951L12.8525 12.8525C12.7301 12.9749 12.5641 13.0436 12.3911 13.0436C12.218 13.0436 12.052 12.9749 11.9297 12.8525C11.8073 12.7301 11.7386 12.5641 11.7386 12.3911C11.7386 12.218 11.8073 12.052 11.9297 11.9297L14.7299 9.13027H8.47811C6.2303 9.1279 4.07524 8.23391 2.4858 6.64447C0.896362 5.05503 0.00237372 2.89997 0 0.652162C0 0.479198 0.0687097 0.313318 0.191014 0.191014C0.313318 0.0687099 0.479198 0 0.652162 0C0.825126 0 0.991006 0.0687099 1.11331 0.191014C1.23561 0.313318 1.30432 0.479198 1.30432 0.652162C1.30648 2.55411 2.06298 4.37753 3.40786 5.72241C4.75274 7.06729 6.57616 7.82379 8.47811 7.82594H14.7299L11.9297 5.02654C11.8073 4.90417 11.7386 4.73819 11.7386 4.56513C11.7386 4.39207 11.8073 4.2261 11.9297 4.10373C12.052 3.98136 12.218 3.91261 12.3911 3.91261C12.5641 3.91261 12.7301 3.98136 12.8525 4.10373L16.7655 8.0167C16.8261 8.07727 16.8742 8.1492 16.907 8.22837C16.9398 8.30754 16.9567 8.3924 16.9567 8.47811C16.9567 8.56381 16.9398 8.64867 16.907 8.72785C16.8742 8.80702 16.8261 8.87894 16.7655 8.93951Z",
    fill: "#0066CC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFollowuparrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/followuparrow.dc49707f0a5b3d9c79a2d9a3db2f1d9c.svg";